// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"bY-z","sponsoredTooltipWrapper":"cY-z","sponsoredTooltip":"dY-z","newCard":"eY-z"};